import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { ContentEdit, ContentReadOnly } from './ContentForm';
import { useTestContactUsMutation } from '../../../services/rtkQueryServices';
import { Button } from '@mui/material';
import { useAppSelector } from '../../../store/reduxHooks';

export default function ContentPages({}: any) {
  return (
    <GenericCrudPage
      key='content-pages-page'
      tableColumns={[
        {
          field: 'uuid',
          headerName: 'UUID',
          width: 200,
        },
      ]}
      singularName='Page'
      pageTitle='Content Pages'
      resource='pages'
      allowAdd={false}
      allowEdit={false}
      allowDelete={false}
      ReadOnlyComponent={ContentReadOnly}
      EditFormComponent={ContentEdit}
      newPayload={{
        title: '',
        name: '',
        about: '',
      }}
      validateFn={(data: any) => {
        return [true, []];
      }}
    />
  );
}
